import { render, staticRenderFns } from "./ArtisanText.vue?vue&type=template&id=02b490a9"
import script from "./ArtisanText.vue?vue&type=script&lang=js"
export * from "./ArtisanText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports